var _metadata, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\r\nCreated by potrace 1.16, written by Peter Selinger 2001-2019\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915 4394 c-820 -33 -1141 -62 -1311 -119 -213 -71 -402 -252 -487 -465 -81 -204 -117 -597 -117 -1270 0 -663 36 -1048 117 -1250 91 -226 276 -398 506 -469 354 -109 1987 -156 3132 -90 646 37 828 79 1021 239 153 127 239 291 283 540 43 238 53 403 58 928 7 659 -15 1006 -81 1264 -71 279 -272 495 -539 577 -134 41 -447 75 -942 102 -187 10 -1464 20 -1640 13z m1315 -414 c612 -20 935 -45 1113 -86 115 -27 211 -103 265 -209 77 -153 114 -663 101 -1380 -9 -458 -44 -770 -100 -891 -30 -63 -120 -153 -183 -183 -117 -54 -437 -85 -1161 -111 -933 -34 -2260 15 -2518 94 -99 30 -184 102 -232 195 -79 158 -118 673 -103 1396 9 490 44 774 110 897 57 108 159 178 294 204 169 32 518 56 1059 74 561 18 775 18 1355 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2050 2550 c0 -445 3 -810 6 -810 13 0 1394 803 1394 810 0 8 -1381 810 -1394 810 -3 0 -6 -364 -6 -810z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.0978a462f41ecd86350e561cce401d89.svg";
export { ForwardRef as ReactComponent };